export const openGoogleMap = (address: string, win: Window = window): void => {
  if (!address) {
    console.error('Address is incorrect.');
    return;
  }
  const encodedAddress = encodeURIComponent(address);
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  win.open(mapUrl, '_blank');
};
